var _desc, _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1281_2058"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "icon-park-outline:link",
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "icon-park-outline:link",
    width: 24,
    height: 24,
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1281_2058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3535 4.78247L4.92871 12.2074C4.08496 13.0514 3.61133 14.1958 3.61133 15.3892C3.61133 16.5825 4.08496 17.7271 4.92871 18.5709C5.34668 18.9888 5.84277 19.3203 6.38867 19.5464C6.93457 19.7726 7.52051 19.889 8.11133 19.889C8.70215 19.889 9.28711 19.7726 9.83301 19.5464C10.3789 19.3203 10.875 18.9888 11.293 18.5709L20.1318 9.73242C20.4111 9.45386 20.6318 9.12317 20.7822 8.75916C20.9336 8.39514 21.0107 8.005 21.0107 7.61096C21.0107 7.21692 20.9336 6.82678 20.7822 6.46277C20.6318 6.09875 20.4111 5.76807 20.1318 5.4895C19.8535 5.21082 19.5225 4.98975 19.1592 4.83899C18.7949 4.68823 18.4043 4.6106 18.0107 4.6106C17.6162 4.6106 17.2266 4.68823 16.8623 4.83899C16.498 4.98975 16.168 5.21082 15.8887 5.4895L7.05078 14.3285C6.91113 14.4678 6.80078 14.6331 6.72559 14.8151C6.65039 14.9971 6.61133 15.1923 6.61133 15.3892C6.61133 15.5862 6.65039 15.7812 6.72559 15.9633C6.80078 16.1453 6.91113 16.3107 7.05078 16.45C7.33203 16.7312 7.71289 16.8892 8.11133 16.8892C8.50879 16.8892 8.89062 16.7312 9.17188 16.45L16.5967 9.0249",
    stroke: "#7F56D9",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPark);
export default __webpack_public_path__ + "static/media/ic_park.5c1aff218f73abeca2358ca1c733d12c.svg";
export { ForwardRef as ReactComponent };